import { DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ICON_PATH_TOKEN } from '@shared/ui-shared';
import { ButtonDirective } from '../../directives/button/button.directive';

@Component({
  selector: 'csl-leave-page-dialog',
  standalone: true,
  imports: [ButtonDirective],
  templateUrl: './leave-page-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeavePageDialogComponent {
  private dialogRef = inject(DialogRef);
  iconPath = inject(ICON_PATH_TOKEN);

  close(isOk: boolean) {
    this.dialogRef.close(isOk);
  }
}
